<template>
  <vs-popup class="holamundo" :title="title" :active.sync="addNewGeofenceCategoryLocal" @vs-close="closeForm">
    <div>
      <form class="">
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px">
          <label class="vs-input--label">Nama Geofence Type<sup>*</sup></label>
          <div class="vs-con-input">
            <input type="text" v-model="dataForm.geofence_type" name="geofence_name"
              class="vs-inputx vs-input--input normal" style="border: 1px solid rgba(0, 0, 0, 0.2)" />
          </div>
        </div>
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px">
          <label class="vs-input--label">Ignore Alert (Dry)<sup>*</sup></label>
          <div class="vs-con-input">
            <vs-select v-model="dataForm.ignore_alerts_dry" class="w-full" multiple>
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="(item, index) in selectedIgnoreAlerts" />
            </vs-select>
          </div>
        </div>
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px">
          <label class="vs-input--label">Ignore Alert (Fresh)<sup>*</sup></label>
          <div class="vs-con-input">
            <vs-select v-model="dataForm.ignore_alerts_fresh" class="w-full" multiple>
              <vs-select-item :key="index" :value="item.value" :text="item.text"
                v-for="(item, index) in selectedIgnoreAlerts" />
            </vs-select>
          </div>
        </div>
        <!-- <div
          class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px">
          <label class="vs-input--label">Vehicle Type<sup>*</sup></label>
          <div class="vs-con-input">
            <vs-select v-model="dataForm.vehicle_type" class="w-full" multiple>
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in selectedVehicleType" />
            </vs-select>
          </div>
        </div> -->
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px">
          <label class="vs-input--label">Alert In<sup>*</sup></label>
          <div class="vs-con-input">
            <vs-select :disabled="!inputIgnore.alert_in" v-model="dataForm.alert_in" class="w-full">
              <vs-select-item v-for="(type, index) in selectedAlerts" :key="index" :value="type.value"
                :text="type.text" />
            </vs-select>
          </div>
        </div>
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px">
          <label class="vs-input--label">Alert Out<sup>*</sup></label>
          <div class="vs-con-input">
            <vs-select :disabled="!inputIgnore.alert_out" v-model="dataForm.alert_out" class="w-full">
              <vs-select-item v-for="(type, index) in selectedAlerts" :key="index" :value="type.value"
                :text="type.text" />
            </vs-select>
          </div>
        </div>
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex flex-col"
          style="width: 600px;">
          <label class="vs-input--label">Overspeed threshold <sup>*</sup> ({{ vehicleCategoryOverspeed.map(val =>
            val).join(', ') }})</label>
          <div class="vs-inputx vs-input--input normal input-container" style="
              display: flex;
              align-items: center;
              border: 1px solid rgba(0, 0, 0, 0.2);
              ">
            <div v-if="!inputIgnore.overspeed" class="w-full h-full" style="left:0;background: grey;opacity: 0.5;z-index: 1;position: absolute; border-radius: 3px;"></div>
            <input type="number" :disabled="!inputIgnore.overspeed" v-model="dataForm.overspeed" name="overspeed"
              class="w-full" style="border: none" />
            <span style="color: gray; font-size: 14px; font-weight: bold">KM/H</span>
          </div>
        </div>

        <div class="vs-component vs-con-input-label vs-input mb-5 vs-input-primary flex flex-row w-full"
          style="gap: 10px;">
          <div style="flex: 1">
            <label class="vs-input--label">Overstay Engine ON (DRY)<sup>*</sup></label>
            <div class="vs-inputx vs-input--input normal flex justify-between">
              <div v-if="!inputIgnore.overstay_engine_on_dry" class="w-full h-full" style="left:0;top:0;background: grey;opacity: 0.5;;z-index: 1;position: absolute; border-radius: 3px;"></div>

              <input type="number" :disabled="!inputIgnore.overstay_engine_on_dry" v-model="dataForm.overstay_on_dry"
                name="overstay_on_dry" class="w-full" style="border: none" />
              <span style="color: gray; font-size: 14px; font-weight: bold">Menit</span>
            </div>
          </div>
          <div style="flex: 1">
            <label class="vs-input--label">Overstay Engine OFF (DRY)<sup>*</sup></label>
            <div class="vs-inputx vs-input--input normal flex justify-between">
            <div v-if="!inputIgnore.overstay_engine_off_dry" class="w-full h-full" style="left:0;top:0;background: grey;opacity: 0.5;;z-index: 1;position: absolute; border-radius: 3px;"></div>

              <input type="number" :disabled="!inputIgnore.overstay_engine_off_dry" v-model="dataForm.overstay_off_dry"
                name="overstay_off_dry" class="w-full" style="border: none" />
              <span style="color: gray; font-size: 14px; font-weight: bold">Menit</span>
            </div>
          </div>
        </div>
        <div class="vs-component vs-con-input-label vs-input mb-5 w-full vs-input-primary flex justify-between"
          style="gap:10px">
          <div style="flex: 1;">
            <label class="vs-input--label">Overstay Engine ON (FRESH)<sup>*</sup></label>
            <div class="vs-inputx vs-input--input normal input-container" style="
                display: flex;
                align-items: center;
                border: 1px solid rgba(0, 0, 0, 0.2);
              ">
            <div v-if="!inputIgnore.overstay_engine_on_fresh" class="w-full h-full" style="left:0;top:0;background: grey;opacity: 0.5;;z-index: 1;position: absolute; border-radius: 3px;"></div>

              <input type="number" :disabled="!inputIgnore.overstay_engine_on_fresh"
                v-model="dataForm.overstay_on_fresh" name="overstay_on_fresh" class="w-full" style="border: none" />
              <span style="color: gray; font-size: 14px; font-weight: bold">Menit</span>
            </div>
          </div>
          <div style="flex: 1;">
            <label class="vs-input--label">Overstay Engine OFF (FRESH)<sup>*</sup></label>
            <!-- <div style="z-index: 1; position: absolute;" class="w-full h-full bg-black"></div> -->
            <div class="vs-inputx vs-input--input normal input-container" style="
                display: flex;
                align-items: center;
                border: 1px solid rgba(0, 0, 0, 0.2);
              ">
            <div v-if="!inputIgnore.overstay_engine_off_fresh" class="w-full h-full" style="left:0;top:0;background: grey;opacity: 0.5;;z-index: 1;position: absolute; border-radius: 3px;"></div>

              <input type="number" :disabled="!inputIgnore.overstay_engine_off_fresh"
                v-model="dataForm.overstay_off_fresh" name="overstay_off_fresh" class="w-full" style="border: none" />
              <span style="color: gray; font-size: 14px; font-weight: bold">Menit</span>
            </div>
          </div>
        </div>

        <div class="flex h-full justify-center">
          <div style="columns: 2; gap: 50px; margin: 0 50px">
            <div>
              <vs-button color="danger" @click="closeForm"> Batal </vs-button>
            </div>
            <div>
              <vs-button v-if="!editMode" color="primary" @click="submitForm">Tambah</vs-button>
              <vs-button v-if="editMode" color="primary" @click="submitForm">Edit</vs-button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </vs-popup>
</template>

<script>
import { create } from 'nipplejs';
import * as REPO from '../../../repository/index'

export default {
  props: {
    title: String,
    addNewGeofenceCategory: {
      type: Boolean,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      vehicleCategoryOverspeed: ['DRY', 'FRESH'],
      dataForm: {
        geofence_type: '',
        overspeed: 0,
        overstay_on_dry: 0,
        overstay_off_dry: 0,
        overstay_on_fresh: 0,
        overstay_off_fresh: 0,
        alert_in: '',
        alert_out: '',
        ignore_alerts_dry: [],
        ignore_alerts_fresh: [],
        vehicle_type: []
      },
      inputIgnore: {
        overspeed: true,
        alert_in: true,
        alert_out: true,
        overstay_engine_on_dry: true,
        overstay_engine_off_dry: true,
        overstay_engine_on_fresh: true,
        overstay_engine_off_fresh: true,
      },
      selectedAlerts: [
        {
          text: 'Active',
          value: 1,
        },
        {
          text: 'Inactive',
          value: 0,
        },
      ],
      selectedVehicleType: [
        {
          text: 'Dry',
          value: 'dry',
        },
        {
          text: 'Fresh',
          value: 'fresh',
        }
      ],
      selectedIgnoreAlerts: [

      ],
    }
  },
  created() {
    this.getListAlert()
  },
  watch: {
    //check array ignore_alerts
    'dataForm.ignore_alerts_dry': function (val) {
      if (val.includes('OVERSPEED')) {
        this.vehicleCategoryOverspeed = this.vehicleCategoryOverspeed.filter((x) => x != 'DRY')
      } else {
        this.vehicleCategoryOverspeed.push('DRY')
      }
      if (val.includes('OVERSTAY_ENGINE_ON')) {
        this.inputIgnore.overstay_engine_on_dry = false
      } else {
        this.inputIgnore.overstay_engine_on_dry = true
      }
      if (val.includes('OVERSTAY_ENGINE_OFF')) {
        this.inputIgnore.overstay_engine_off_dry = false
      } else {
        this.inputIgnore.overstay_engine_off_dry = true
      }
    },
    'dataForm.ignore_alerts_fresh': function (val) {
      if (val.includes('OVERSPEED')) {
        this.vehicleCategoryOverspeed = this.vehicleCategoryOverspeed.filter((x) => x != 'FRESH')
      } else {
        this.vehicleCategoryOverspeed.push('FRESH')
      }
      if (val.includes('OVERSTAY_ENGINE_ON')) {
        this.inputIgnore.overstay_engine_on_fresh = false
      } else {
        this.inputIgnore.overstay_engine_on_fresh = true
      }
      if (val.includes('OVERSTAY_ENGINE_OFF')) {
        this.inputIgnore.overstay_engine_off_fresh = false
      } else {
        this.inputIgnore.overstay_engine_off_fresh = true
      }
    },
    'vehicleCategoryOverspeed': function (val) {
      if (val.length == 0) {
        this.inputIgnore.overspeed = false
      } else {
        this.inputIgnore.overspeed = true
      }
    },
  },
  computed: {
    addNewGeofenceCategoryLocal: {
      get() {
        // if (!this.editMode) this.clearFields()
        // console.log(this.dataEdit)
        if (this.addNewGeofenceCategory && this.editMode) {
          this.dataForm.geofence_type = this.dataEdit.geofence_type
          this.dataForm.overspeed = this.dataEdit.overspeed
          this.dataForm.overstay_on_dry = this.dataEdit.overstay_on_dry
          this.dataForm.overstay_off_dry = this.dataEdit.overstay_off_dry
          this.dataForm.overstay_on_fresh = this.dataEdit.overstay_on_fresh
          this.dataForm.overstay_off_fresh = this.dataEdit.overstay_off_fresh
          this.dataForm.alert_in = this.dataEdit.alert_in
          this.dataForm.alert_out = this.dataEdit.alert_out

          this.dataForm.ignore_alerts_fresh = this.dataEdit.ignore_alerts_fresh
          this.dataForm.ignore_alerts_dry = this.dataEdit.ignore_alerts_dry
          this.dataForm.vehicle_type = this.dataEdit.vehicle_type
        }
        return JSON.parse(this.addNewGeofenceCategory)
      },
      set(val) {
        if (!val) {
          this.clearFields()
          this.$emit('closeModal', false)
        }
      },
    },
  },
  methods: {
    submitForm() {
      if (this.editMode) {
        REPO.updateGeofenceCategory(this.dataForm, this.dataEdit.id)
          .then((res) => {
            this.$vs.notify({
              title: 'Success',
              text: 'Success Update Data',
              color: 'success',
              position: 'top-right',
            })
            this.$emit('closeModal', false)
          })
          .catch((err) => {
            this.$vs.notify({
              title: 'Error',
              text: err.response.data,
              color: 'danger',
              position: 'top-right',
            })
          })
      } else {
        REPO.postGeofenceCategory(this.dataForm)
          .then((res) => {
            this.$vs.notify({
              title: 'Success',
              text: 'Success Create Data',
              color: 'success',
              position: 'top-right',
            })
            this.$emit('closeModal', false)
          })
          .catch((err) => {
            this.$vs.notify({
              title: 'Error',
              text: err.response.data,
              color: 'danger',
              position: 'top-right',
            })
          })
      }
    },
    getListAlert() {
      REPO.getListAlert().then((res) => {
        console.log(res.data.data)
        this.selectedIgnoreAlerts = res.data.data.filter((x) => x.alert_code !== "GEO_IN" && x.alert_code !== "GEO_OUT")
          .map((x) => {
            return {
              value: x.alert_code,
              text: x.alert_name,
            }
          })
      })
    },
    closeForm() {
      this.clearFields()
      this.$emit('closeModal', false)
    },
    clearFields() {
      this.dataForm = {
        geofence_type: '',
        overspeed: '',
        overstay_on_dry: '',
        overstay_off_dry: '',
        overstay_on_fresh: '',
        overstay_off_fresh: '',
        alert_in: '',
        alert_out: '',
        ignore_alerts_dry: [],
        ignore_alerts_fresh: [],
        vehicle_type: []
      }
    },
  },
}
</script>

<style>
.vs-table {}

.input-container:focus-within {
  border-color: blue;
}
</style>
